module.exports = __webpack_public_path__ + "catalog/items/firesafety/direction-left/direction-left.svg";